import { graphql } from 'gatsby';
import { createGatsbyPageComponent, ContentEntityTaxonomyLayout } from '@shapeable/ui';

export default createGatsbyPageComponent('Video', { layout: ContentEntityTaxonomyLayout });

export const QUERY = graphql`
query VideoQuery($id: ID!) {
  platform { video(id: $id) {
    id name url slug typeLabel badge path updated __typename _schema { label pluralLabel } 
    published
    description { text }
    typeLabel
    type { id name slug }
    thumbnail {
      url
    }
    color { id name value }
    people {
      __typename
      role { id name }
      openGraph { image { url } }
      id name slug path
      organisation { id name }
      linkedin
      photo { id url url2x thumbnails { bubble { url url2x } } }
    }
    authors {
      __typename
      role { id name }
      isMember
      bio { id text html }
      openGraph { image { url } }
      id name slug
      organisation { id name }
      linkedin
      photo { id url url2x thumbnails { bubble { url url2x } } }
    }
    challenge {
      icon { id name component }
      color { id name value }
      backgroundImage { id image { id url url2x } }
      id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
      openGraph { 
        id title 
        image { 
          id url url2x 
          thumbnails { 
            id bubbleMedium { id url url2x }
          }
        } 
      }
    }
    challenges {
      id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
      icon { id name component }
      color { id name value }
      advertisements {
        id name slug url __typename
        description { id text }
        image {
          image { id url url2x type width height }
          landscapeImage { url url2x width height }
          tabletImage { id url url2x width height }
          portraitImage { id url url2x width height }
        }
      }
    }
    embeds {
      advertisements {
        id name slug url __typename
        description { id text }
        image {
          image { id url url2x type width height }
          landscapeImage { url url2x width height }
          tabletImage { id url url2x width height }
          portraitImage { id url url2x width height }
        }
      }
    }
  } }
}
`;
